import styled, { css } from 'styled-components';
import { isDefined } from '../../helpers/defined';
import { pointerEventsNoneStyle } from '../../tokens/pointer-events';
import { width } from '../../style/width';
const FormContainer = styled.div`
  position: relative;
  background-color: transparent;
  flex-grow: 1;
  width: 100%;
  ${({
  $width
}) => isDefined($width) && css`
      flex-shrink: 0;
      ${width($width)}
    `}
  ${({
  $inactive
}) =>
// Makes everything inside not touchable/clickable
$inactive && `
      & * {
        ${pointerEventsNoneStyle}
      }
    `}
`;
export default FormContainer;